export const collections = [
  {
    id: 1,
    name: 'Noches de Gala',
    year: '2025',
    description: 'Vestidos de gala diseñados para eventos exclusivos. Seda natural, encaje francés y bordados artesanales en cada pieza.',
    featured: true,
    image: 'https://readdy.ai/api/search-image?query=elegant-haute-couture-gown-full-length-silk-lace-black-red-carpet-evening-wear-luxury-fashion-editorial-photography-minimal-dark-background-spotlight-grain-texture-cinematic&width=800&height=1000&seq=60&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=elegant-haute-couture-gown-full-length-silk-lace-black-red-carpet-evening-wear-luxury-fashion-editorial-photography-minimal-dark-background-spotlight-grain-texture-cinematic&width=800&height=1000&seq=60&orientation=portrait',
      'https://readdy.ai/api/search-image?query=close-up-haute-couture-dress-embroidered-lace-detail-gold-thread-handmade-beading-luxury-textile-art-dark-background-editorial-photography-soft-lighting&width=800&height=1000&seq=61&orientation=portrait',
      'https://readdy.ai/api/search-image?query=haute-couture-gown-back-view-silk-train-flowing-elegant-red-carpet-dramatic-lighting-luxury-fashion-editorial-dark-background-grain-texture-cinematic&width=800&height=1000&seq=62&orientation=portrait',
    ],
  },
  {
    id: 2,
    name: 'Orígenes Dorados',
    year: '2024',
    description: 'Colección inspirada en los ateliers de París y Roma. Chaquetas bordadas en oro, brocados italianos y detalles barrocos.',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=haute-couture-jacket-gold-embroidery-baroque-pattern-rich-brocade-fabric-black-background-luxury-fashion-editorial-photography-soft-spotlight-grain-texture-cinematic&width=800&height=1000&seq=63&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=haute-couture-jacket-gold-embroidery-baroque-pattern-rich-brocade-fabric-black-background-luxury-fashion-editorial-photography-soft-spotlight-grain-texture-cinematic&width=800&height=1000&seq=63&orientation=portrait',
      'https://readdy.ai/api/search-image?query=close-up-gold-embroidery-detail-on-black-velvet-fabric-luxury-handcraft-haute-couture-artisanal-beading-dark-background-editorial-photography-soft-lighting&width=800&height=1000&seq=64&orientation=portrait',
      'https://readdy.ai/api/search-image?query=elegant-brocade-fabric-texture-rich-golden-pattern-luxury-textile-close-up-dark-background-haute-couture-material-editorial-photography-soft-lighting&width=800&height=1000&seq=65&orientation=portrait',
    ],
  },
  {
    id: 3,
    name: 'Seda Pintada',
    year: '2024',
    description: 'Piezas únicas en seda pintada a mano, técnica premiada internacionalmente. Cada prenda es una obra de arte irrepetible.',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=hand-painted-silk-dress-artistic-watercolor-flowers-elegant-haute-couture-gown-flowing-fabric-soft-natural-lighting-minimal-background-luxury-fashion-editorial-photography&width=800&height=1000&seq=66&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=hand-painted-silk-dress-artistic-watercolor-flowers-elegant-haute-couture-gown-flowing-fabric-soft-natural-lighting-minimal-background-luxury-fashion-editorial-photography&width=800&height=1000&seq=66&orientation=portrait',
      'https://readdy.ai/api/search-image?query=close-up-hand-painted-silk-fabric-detail-artistic-brush-strokes-watercolor-texture-luxury-haute-couture-material-soft-lighting-editorial-photography&width=800&height=1000&seq=67&orientation=portrait',
      'https://readdy.ai/api/search-image?query=elegant-hand-painted-silk-dress-draping-flowing-movement-artistic-fashion-luxury-couture-soft-lighting-minimal-background-editorial-photography-grain-texture&width=800&height=1000&seq=68&orientation=portrait',
    ],
  },
  {
    id: 4,
    name: 'Velo Nupcial',
    year: '2023',
    description: 'Vestidos de novia artesanales con encaje chantilly, tul francés y bordados personalizados. El día más especial merece lo mejor.',
    featured: false,
    image: 'https://readdy.ai/api/search-image?query=elegant-wedding-dress-haute-couture-bridal-gown-lace-veil-chantilly-embroidery-soft-white-lighting-minimal-background-luxury-fashion-editorial-photography-grain-texture&width=800&height=1000&seq=69&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=elegant-wedding-dress-haute-couture-bridal-gown-lace-veil-chantilly-embroidery-soft-white-lighting-minimal-background-luxury-fashion-editorial-photography-grain-texture&width=800&height=1000&seq=69&orientation=portrait',
      'https://readdy.ai/api/search-image?query=close-up-chantilly-lace-detail-wedding-dress-embroidery-pearls-beading-soft-white-lighting-luxury-bridal-haute-couture-editorial-photography&width=800&height=1000&seq=70&orientation=portrait',
      'https://readdy.ai/api/search-image?query=elegant-bridal-veil-tulle-lace-detail-flowing-soft-lighting-white-background-luxury-wedding-haute-couture-editorial-photography-grain-texture&width=800&height=1000&seq=71&orientation=portrait',
    ],
  },
];

export const creativeProcess = [
  {
    step: 1,
    title: 'Consulta Privada',
    description: 'Te recibimos en nuestro atelier del Eixample para conocerte, entender tu visión y explorar juntos las posibilidades de tu prenda soñada.',
    icon: 'ri-user-heart-line',
  },
  {
    step: 2,
    title: 'Diseño Conceptual',
    description: 'Anthony desarrolla bocetos exclusivos inspirados en tu personalidad, el evento y la energía que deseas transmitir con tu prenda.',
    icon: 'ri-palette-line',
  },
  {
    step: 3,
    title: 'Selección de Materiales',
    description: 'Elegimos sedas, encajes, bordados y adornos de las mejores proveedoras europeas. Cada material cuenta una historia.',
    icon: 'ri-t-shirt-line',
  },
  {
    step: 4,
    title: 'Patronaje Artesanal',
    description: 'Creamos el patrón a medida exacta de tu cuerpo. Cada curva y cada línea se diseña para realzar tu figura de forma única.',
    icon: 'ri-scissors-cut-line',
  },
  {
    step: 5,
    title: 'Bordado y Detalle',
    description: 'Nuestros artesanos trabajan cada bordado a mano con dedicación absoluta. El detalle es donde reside el alma de la pieza.',
    icon: 'ri-separator',
  },
  {
    step: 6,
    title: 'Pruebas Finales',
    description: 'Realizamos sesiones de prueba para perfeccionar cada ajuste. La prenda no está completa hasta que se siente como una segunda piel.',
    icon: 'ri-checkbox-circle-line',
  },
];

export const pressFeatures = [
  {
    magazine: "L'Officiel",
    quote: 'Anthony Sánchez representa la nueva vanguardia de la alta costura española con un toque parisino inconfundible.',
    year: '2024',
  },
  {
    magazine: 'Cosmopolitan',
    quote: 'Su colección Orígenes Dorados redefine el lujo artesanal contemporáneo con una maestría técnica sorprendente.',
    year: '2023',
  },
  {
    magazine: 'Grazia',
    quote: 'El atelier de Barcelona es un templo donde cada prenda cuenta una historia de pasión, viaje y dedicación absoluta.',
    year: '2023',
  },
];